<template>
  <div class="confirmemailpage">

    <div>
      <confirmemail :hash="hash"/>
    </div>

  </div>
 
</template>

<script>
// @ is an alias to /src
import confirmemail from '@/components/common/confirmemailhash/index.vue'

export default {
    name: 'confirmemailpage',
    data : function(){
        return {
            hash : ''
        }
    },
    components: {
        confirmemail
    },

    created : function(){


        this.hash = this.$route.query.hash || ""
    }
}
</script>